import OPTIONAL_TAGS from "./optionalTags";

const byColorMenus1 = JSON.parse(JSON.stringify(OPTIONAL_TAGS)).filter(
  e => e.color && [1, 2, 3, 4, 5].indexOf(e.id) > -1
);
const byColorMenus3 = JSON.parse(JSON.stringify(OPTIONAL_TAGS)).filter(
  e => e.color && [0, 2, 10, 11, 12].indexOf(e.id) > -1
);
const byColorMenus4 = JSON.parse(JSON.stringify(OPTIONAL_TAGS)).filter(
  e => e.color && [0, 2, 10, 11, 12].indexOf(e.id) > -1
);

byColorMenus1.forEach(function(menu) {
  menu.url = `${menu.url}&tagIds[]=47`;
});

byColorMenus3.forEach(function(menu) {
  menu.url = `${menu.url}&tagIds[]=49`;
});

byColorMenus4.forEach(function(menu) {
  menu.url = `${menu.url}&tagIds[]=50`;
});

export default {
  menu1: {
    byPurpose: [
      { id: 1, title: "お祝い全般", url: "/products?tagIds[]=1&tagIds[]=47" },
      { id: 2, title: "就任祝い", url: "/products?tagIds[]=2&tagIds[]=47" },
      { id: 3, title: "昇進祝い", url: "/products?tagIds[]=3&tagIds[]=47" },
      { id: 4, title: "移転祝い", url: "/products?tagIds[]=4&tagIds[]=47" },
      { id: 5, title: "開店祝い", url: "/products?tagIds[]=5&tagIds[]=47" },
      { id: 6, title: "開業祝い", url: "/products?tagIds[]=6&tagIds[]=47" },
      { id: 7, title: "開院祝い", url: "/products?tagIds[]=7&tagIds[]=47" },
      { id: 8, title: "上場祝い", url: "/products?tagIds[]=8&tagIds[]=47" },
      { id: 9, title: "栄転祝い", url: "/products?tagIds[]=9&tagIds[]=47" },
      { id: 10, title: "退職祝い", url: "/products?tagIds[]=10&tagIds[]=47" },
      { id: 11, title: "公演祝い", url: "/products?tagIds[]=11&tagIds[]=47" },
      { id: 12, title: "周年記念", url: "/products?tagIds[]=12&tagIds[]=47" },
      {
        id: 13,
        title: "竣工・落成祝い",
        url: "/products?tagIds[]=13&tagIds[]=47"
      },
      { id: 14, title: "新築祝い", url: "/products?tagIds[]=14&tagIds[]=47" }
    ],
    byBudget: [
      {
        id: 1,
        title: "10,000円以内",
        url: "/products?q%5Bprice_lteq%5D=10000&tagIds[]=47"
      },
      {
        id: 2,
        title: "30,000円以内",
        url: "/products?q%5Bprice_lteq%5D=30000&tagIds[]=47"
      },
      {
        id: 3,
        title: "50,000円以内",
        url: "/products?q%5Bprice_lteq%5D=50000&tagIds[]=47"
      },
      {
        id: 4,
        title: "70,000円以内",
        url: "/products?q%5Bprice_lteq%5D=70000&tagIds[]=47"
      },
      {
        id: 5,
        title: "70,000円以上",
        url: "/products?q%5Bprice_gteq%5D=70000&tagIds[]=47"
      }
    ],
    byColor: byColorMenus1,
    byKind: [
      {
        id: 52,
        title: "大輪胡蝶蘭",
        url: "/products?tagIds[]=52&tagIds[]=47"
      },
      {
        id: 53,
        title: "エレガンス胡蝶蘭",
        url: "/products?tagIds[]=53&tagIds[]=47"
      },
      {
        id: 54,
        title: "マイクロ胡蝶蘭",
        url: "/products?tagIds[]=54&tagIds[]=47"
      },
      {
        id: 55,
        title: "ミディ胡蝶蘭",
        url: "/products?tagIds[]=55&tagIds[]=47"
      }
    ]
  },
  menu2: {
    byPurpose: [
      { id: 1, title: "お祝い全般", url: "/products?tagIds[]=1&tagIds[]=48" },
      { id: 2, title: "就任祝い", url: "/products?tagIds[]=2&tagIds[]=48" },
      { id: 3, title: "昇進祝い", url: "/products?tagIds[]=3&tagIds[]=48" },
      { id: 4, title: "移転祝い", url: "/products?tagIds[]=4&tagIds[]=48" },
      { id: 5, title: "開店祝い", url: "/products?tagIds[]=5&tagIds[]=48" },
      { id: 6, title: "開業祝い", url: "/products?tagIds[]=6&tagIds[]=48" },
      { id: 7, title: "開院祝い", url: "/products?tagIds[]=7&tagIds[]=48" },
      { id: 8, title: "上場祝い", url: "/products?tagIds[]=8&tagIds[]=48" },
      { id: 9, title: "栄転祝い", url: "/products?tagIds[]=9&tagIds[]=48" },
      { id: 10, title: "退職祝い", url: "/products?tagIds[]=10&tagIds[]=48" },
      { id: 11, title: "公演祝い", url: "/products?tagIds[]=11&tagIds[]=48" },
      { id: 12, title: "周年記念", url: "/products?tagIds[]=12&tagIds[]=48" },
      {
        id: 15,
        title: "引っ越し祝い",
        url: "/products?tagIds[]=15&tagIds[]=48"
      },
      { id: 14, title: "新築祝い", url: "/products?tagIds[]=14&tagIds[]=48" }
    ],
    byBudget: [
      {
        id: 1,
        title: "10,000円以内",
        url: "/products?q%5Bprice_lteq%5D=10000&tagIds[]=48"
      },
      {
        id: 2,
        title: "30,000円以内",
        url: "/products?q%5Bprice_lteq%5D=30000&tagIds[]=48"
      },
      {
        id: 3,
        title: "50,000円以内",
        url: "/products?q%5Bprice_lteq%5D=50000&tagIds[]=48"
      }
    ],
    byKind: [
      { id: 56, title: "パキラ", url: "/products?tagIds[]=56&tagIds[]=48" },
      { id: 57, title: "ユッカ", url: "/products?tagIds[]=57&tagIds[]=48" },
      { id: 58, title: "オーガスタ", url: "/products?tagIds[]=58&tagIds[]=48" },
      {
        id: 59,
        title: "ベンジャミン",
        url: "/products?tagIds[]=59&tagIds[]=48"
      },
      {
        id: 60,
        title: "ドラセナ・マッサンゲアナ",
        url: "/products?tagIds[]=60&tagIds[]=48"
      },
      { id: 61, title: "ポトス", url: "/products?tagIds[]=61&tagIds[]=48" },
      { id: 62, title: "カポック", url: "/products?tagIds[]=62&tagIds[]=48" },
      {
        id: 63,
        title: "ウンベラータ",
        url: "/products?tagIds[]=63&tagIds[]=48"
      }
    ]
  },
  menu3: {
    byPurpose: [
      { id: 1, title: "お祝い全般", url: "/products?tagIds[]=1&tagIds[]=49" },
      { id: 2, title: "就任祝い", url: "/products?tagIds[]=2&tagIds[]=49" },
      { id: 3, title: "昇進祝い", url: "/products?tagIds[]=3&tagIds[]=49" },
      { id: 4, title: "移転祝い", url: "/products?tagIds[]=4&tagIds[]=49" },
      { id: 5, title: "開店祝い", url: "/products?tagIds[]=5&tagIds[]=49" },
      { id: 6, title: "開業祝い", url: "/products?tagIds[]=6&tagIds[]=49" },
      { id: 7, title: "開院祝い", url: "/products?tagIds[]=7&tagIds[]=49" },
      { id: 8, title: "上場祝い", url: "/products?tagIds[]=8&tagIds[]=49" },
      { id: 9, title: "栄転祝い", url: "/products?tagIds[]=9&tagIds[]=49" },
      { id: 10, title: "退職祝い", url: "/products?tagIds[]=10&tagIds[]=49" },
      { id: 11, title: "公演祝い", url: "/products?tagIds[]=11&tagIds[]=49" },
      { id: 12, title: "周年記念", url: "/products?tagIds[]=12&tagIds[]=49" },
      {
        id: 15,
        title: "引っ越し祝い",
        url: "/products?tagIds[]=15&tagIds[]=49"
      },
      { id: 14, title: "新築祝い", url: "/products?tagIds[]=14&tagIds[]=49" }
    ],
    byBudget: [
      {
        id: 1,
        title: "10,000円以内",
        url: "/products?q%5Bprice_lteq%5D=10000&tagIds[]=49"
      },
      {
        id: 2,
        title: "30,000円以内",
        url: "/products?q%5Bprice_lteq%5D=30000&tagIds[]=49"
      },
      {
        id: 3,
        title: "50,000円以内",
        url: "/products?q%5Bprice_lteq%5D=50000&tagIds[]=49"
      },
      {
        id: 4,
        title: "70,000円以内",
        url: "/products?q%5Bprice_lteq%5D=70000&tagIds[]=49"
      },
      {
        id: 5,
        title: "70,000円以上",
        url: "/products?q%5Bprice_gteq%5D=70000&tagIds[]=49"
      }
    ],
    byColor: byColorMenus3,
    byKind: [
      {
        id: 52,
        title: "スタンド花・一段",
        url: "/products?tagIds[]=64&tagIds[]=49"
      },
      {
        id: 53,
        title: "スタンド花・二段",
        url: "/products?tagIds[]=65&tagIds[]=49"
      }
    ]
  },
  menu4: {
    byPurpose: [
      { id: 1, title: "お祝い全般", url: "/products?tagIds[]=1&tagIds[]=50" },
      { id: 2, title: "就任祝い", url: "/products?tagIds[]=2&tagIds[]=50" },
      { id: 3, title: "昇進祝い", url: "/products?tagIds[]=3&tagIds[]=50" },
      { id: 4, title: "移転祝い", url: "/products?tagIds[]=4&tagIds[]=50" },
      { id: 5, title: "開店祝い", url: "/products?tagIds[]=5&tagIds[]=50" },
      { id: 6, title: "開業祝い", url: "/products?tagIds[]=6&tagIds[]=50" },
      { id: 7, title: "開院祝い", url: "/products?tagIds[]=7&tagIds[]=50" },
      { id: 8, title: "上場祝い", url: "/products?tagIds[]=8&tagIds[]=50" },
      { id: 9, title: "栄転祝い", url: "/products?tagIds[]=9&tagIds[]=50" },
      { id: 10, title: "退職祝い", url: "/products?tagIds[]=10&tagIds[]=50" },
      { id: 11, title: "公演祝い", url: "/products?tagIds[]=11&tagIds[]=50" },
      { id: 12, title: "周年記念", url: "/products?tagIds[]=12&tagIds[]=50" },
      {
        id: 13,
        title: "竣工・落成祝い",
        url: "/products?tagIds[]=13&tagIds[]=50"
      },
      { id: 14, title: "新築祝い", url: "/products?tagIds[]=14&tagIds[]=50" }
    ],
    byBudget: [
      {
        id: 1,
        title: "10,000円以内",
        url: "/products?q%5Bprice_lteq%5D=10000&tagIds[]=50"
      },
      {
        id: 2,
        title: "30,000円以内",
        url: "/products?q%5Bprice_lteq%5D=30000&tagIds[]=50"
      },
      {
        id: 3,
        title: "50,000円以内",
        url: "/products?q%5Bprice_lteq%5D=50000&tagIds[]=50"
      },
      {
        id: 4,
        title: "70,000円以内",
        url: "/products?q%5Bprice_lteq%5D=70000&tagIds[]=50"
      },
      {
        id: 5,
        title: "70,000円以上",
        url: "/products?q%5Bprice_gteq%5D=70000&tagIds[]=50"
      }
    ],
    byColor: byColorMenus4
  }
};
